import { ApplicationConfig, importProvidersFrom } from '@angular/core';

import { APP_ENVIRONMENT } from '@seb/web-common/core/constants/environment-token';
import { WebCommonModule } from '@seb/web-common/core/web-common.module';
import { BrandsEnum, SdLibModule } from '@seb/web-design-system/core';

import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      SdLibModule.withBrand(BrandsEnum.krups),
      WebCommonModule.withBrand(BrandsEnum.krups)
    ),
    { provide: APP_ENVIRONMENT, useValue: environment }
  ]
};
